import BaseModel from '../../base/base_model';
import {THEMES_DEFAULTS, THEMES_LIMITS} from './themes_consts';

/**
 *
 *
 *
 */
class ThemesModel extends BaseModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ThemesModel';


	/**
     * The merged result of sdk defaults and user preferences will be stored here ( avoids unnecessary computation )
	 * @type {{}}
	 * @private
	 */
	_mergedPreferences = {
		fonts: {},
		fontSizes: {},
		colors: {}
	};


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this.userPreferences(params);
        this.mergeDefaultsWithUserPrefs(this._mergedPreferences.fonts, THEMES_DEFAULTS.FONT_TYPES,
            this.userPreferences.fontTypes)
            .mergeDefaultsWithUserPrefs(this._mergedPreferences.fontSizes,
                THEMES_DEFAULTS.FONT_SIZES,
                this.userPreferences.fontSizes,
                THEMES_LIMITS.FONT_SIZES)
            .mergeDefaultsWithUserPrefs(this._mergedPreferences.colors,
                THEMES_DEFAULTS.COLORS,
                this.userPreferences.colors);
        this._mergedPreferences.captcha = params.captcha || THEMES_DEFAULTS.CAPTCHA_THEME;
    }

    getMergedPreferences() {
        return this._mergedPreferences;
    }


    userPreferences(userPreferences) {
        this.userPreferences = userPreferences;

        if (this.userPreferences && this.userPreferences.origin) {
            delete this.userPreferences.origin;
        }
    }


    getUserPreferences() {
        return this.userPreferences;
    }


	/**
     * Merges 2 "preference" objects, case insensitive
	 * @param resultObj the result object of the merge
	 * @param defaults default property values ( default object )
	 * @param userObject ( the user preference object which is used )
	 * @param limits an object with the maximum values for properties ( only works for numbers since this was added for font sizes atm )
	 * @returns {ThemesModel}
	 */
    mergeDefaultsWithUserPrefs(resultObj, defaults, userObject, limits) {
		resultObj = Object.assign(resultObj, defaults);
        if (userObject) {
			for (var defaultProp in defaults) {
				for (var userProp in userObject) {
					if (!userObject[userProp]) {
						continue;
					}
					if (defaultProp.toLowerCase() === userProp.toLowerCase()) {
						if (!limits || !limits[defaultProp] || userObject[userProp] <= limits[defaultProp]) {
							resultObj[defaultProp] = userObject[userProp];
						}
						break;
					}
				}
			}
		}
        return this;
    }


    // getFlatObjectByProperty(obj, property) {
    	// let flatObject = Object.assign({}, obj);
    	// Object.keys(flatObject, (key) => {
    	// 	if (typeof flatObject[key] === 'object') {
    	//
	// 		}
	// 	});
    //
	// }

}


export default ThemesModel;